import { afterNextRender, Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';

@Component({
    selector: 'app-login-view',
    templateUrl: './login-view.component.html',
    styleUrls: ['./login-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginViewComponent {
    private readonly dialog = inject(MatDialog);

    title = 'Xanadu';
    signedIn = false;

    constructor() {
        afterNextRender(() => {
            this.openDialog();
        });
    }

    private openDialog(): void {
        this.dialog.open(LoginDialogComponent, {
            width: '600px',
            disableClose: true
        });
    }
}
